import React from "react";
import { Spinner } from "react-bootstrap";
import { BiRadioCircle } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Loading from "../../../Components/Loading";
import { renderPrice } from "../../../Utils/functions";
import { usePlans } from "../Hooks";

const Plan = ({ inList }) => {
  const navigate = useNavigate();
  const {
    data,
    loading,
    selected,
    setSelected,
    buy,
    loadingBtn,
    check,
    loadingCheck,
    form,
  } = usePlans();
  return (
    <>
      {!inList &&
        <header className="d-flex justify-content-between">
          <div className="d-flex  align-items-center">
            <button
              className="btn"
              onClick={() => {
                navigate(-1);
              }}
            >
              <BsArrowRight />
            </button>
            <p className="fs-12 m-0">خرید اشتراک</p>
          </div>
        </header>
      }
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div id="plans">
              <div className={inList ? "col-12" : "col-xl-8"}>
                <div className="card mb-3">
                  <div className="card-header bg-light">
                    <div className="row flex-between-center">
                      <div className="col-sm-auto">
                        <h5 className="mb-2 mb-sm-0">اشتراک های ویژه</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {loading ? (
                        <Loading />
                      ) : (
                        data.map(plan => {
                          return (
                            <div
                              className="col-md-6 mb-4 mb-md-2"
                              onClick={() => {
                                setSelected(
                                  plan.id == selected.id
                                    ? {}
                                    : { ...selected, ...plan }
                                );
                              }}
                            >
                              <div className="form-check mb-0 custom-radio radio-select">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={plan.id == selected.id}
                                />
                                <label
                                  className="form-check-label mb-0 fw-bold d-block"
                                  htmlFor="address-1"
                                >
                                  {plan.title}
                                  <p className="fs-12 fw-400">
                                    {plan.description}
                                  </p>
                                  <span className="radio-select-content">
                                    <span>
                                      {plan.period} روز <br />
                                      <span className="d-block mb-0 pt-2">
                                        {renderPrice(plan.price)}
                                      </span>
                                    </span>
                                  </span>
                                </label>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header bg-light">
                    <h5 className="mb-0">روش پرداخت</h5>
                  </div>
                  <div className="card-body">
                    <div>
                      <div className="border-dashed-bottom my-5" />
                      <div className="row g-3 justify-content-between">
                        <div className="col">
                          <label
                            htmlFor="inputPassword2"
                            className="visually-hidden"
                          >
                            کد تخفیف
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword2"
                            placeholder="کد تخفیف"
                            onChange={({ target: { value } }) => {
                              setSelected({ ...selected, off_code: value });
                            }}
                          />
                        </div>
                        <div className="col-auto">
                          <button
                            type="submit"
                            onClick={check}
                            className="btn btn-primary mb-3"
                          >
                            {loadingCheck ? (
                              <Spinner size="sm" />
                            ) : (
                              "ثبت کد تخفیف"
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="row justify-content-end">
                        <div className=" col-xl-12 col-xxl-8 ps-lg-4 ps-xl-2 ps-xxl-5 text-center text-md-start text-xl-center text-xxl-start">
                          <div className="border-dashed-bottom d-block d-md-none d-xl-block d-xxl-none my-4" />
                          <div className="fs-2 fw-semi-bold">
                            مبلغ کل:{" "}
                            {form.status ? (
                              <div className="">
                                <span
                                  className="text-danger fs-14 fw-300 mx-3 "
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {renderPrice(selected.price) || "-"}
                                </span>
                                <span className="text-primary">
                                  {renderPrice(form.new_total_price) || "-"}
                                </span>
                              </div>
                            ) : (
                              <>
                                <span className="text-primary">
                                  {renderPrice(selected.price) || "-"}
                                </span>
                              </>
                            )}
                          </div>
                          <button
                            className="btn btn-success mt-3 px-5"
                            onClick={buy}
                          >
                            {loadingBtn ? (
                              <Spinner size="sm" />
                            ) : (
                              "تایید و پرداخت"
                            )}
                          </button>
                          <p className="fs--1 mt-3 mb-0">
                            با کلیک بر روی دکمه <strong>تأیید و پرداخت،</strong>{" "}
                            شما با <a href="#!">شرایط و ضوابط موافقت می کنید</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Plan;
